import React, { useState, useEffect, useRef } from 'react';
import Layout from '@/components/Layout';
import WelcomeScreen from '@/components/WelcomeScreen';
import GiverFlow from '@/components/GiverFlow';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const Index = () => {
  const [currentFlow, setCurrentFlow] = useState<'welcome' | 'giver'>('welcome');
  const indexRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  const handleRoleSelect = (role: 'giver' | 'recipient') => {
    if (!user) {
      navigate('/auth');
      return;
    }
    
    if (role === 'recipient') {
      navigate('/market');
    } else {
      setCurrentFlow(role);
    }
  };

  const handleBackToWelcome = () => {
    setCurrentFlow('welcome');
  };
  
  useEffect(() => {
    const handleResetEvent = () => {
      setCurrentFlow('welcome');
    };
    
    const element = indexRef.current;
    if (element) {
      element.addEventListener('reset-to-welcome', handleResetEvent);
    }
    
    return () => {
      if (element) {
        element.removeEventListener('reset-to-welcome', handleResetEvent);
      }
    };
  }, []);

  return (
    <Layout>
      <div id="index-page" ref={indexRef}>
        {currentFlow === 'welcome' && (
          <WelcomeScreen onRoleSelect={handleRoleSelect} />
        )}
        
        {currentFlow === 'giver' && (
          <GiverFlow onBackToWelcome={handleBackToWelcome} />
        )}
      </div>
    </Layout>
  );
};

export default Index;
